module.exports = __webpack_public_path__ + "img/gke-black.270042cf.svg";